import { Theme } from '../types';

export const sunsetTheme: Theme = {
  name: 'sunset',
  colors: {
    gray: {
      50: '#fef7f0',
      100: '#fdedd3',
      200: '#fbd5a6',
      300: '#f7b777',
      400: '#f39247',
      500: '#ef6f20',
      600: '#d0520a',
      700: '#a8400a',
      800: '#883310',
      900: '#722b11',
    },
    accent: {
      50: '#fdf2f8',
      100: '#fce7f3',
      200: '#fbcfe8',
      300: '#f9a8d4',
      400: '#f472b6',
      500: '#ec4899',
      600: '#db2777',
      700: '#be185d',
      800: '#9d174d',
      900: '#831843',
    },
    semantic: {
      success: '#10b981',
      successLight: '#d1fae5',
      error: '#dc2626',
      errorLight: '#fee2e2',
      warning: '#d97706',
      warningLight: '#fef3c7',
      info: '#2563eb',
      infoLight: '#dbeafe',
    },
    background: {
      app: '#fef7f0',
      surface: '#ffffff',
      elevated: '#ffffff',
      navbar: '#ffffff',
      sidebar: '#fdedd3',
      hover: '#fdedd3',
      active: '#fbd5a6',
      blueprint: 'linear-gradient(135deg, #fef7f0 0%, #fbd5a6 100%)',
    },
    text: {
      primary: '#722b11',
      secondary: '#883310',
      tertiary: '#a8400a',
      disabled: '#f7b777',
      inverse: '#ffffff',
      accent: '#be185d',
      onAccent: '#ffffff',
      muted: '#d0520a',
    },
    border: {
      color: '#fbd5a6',
      light: '#fdedd3',
      medium: '#f7b777',
    },
    button: {
      bg: '#fef7f0',
      bgHover: '#fdedd3',
      bgActive: '#fbd5a6',
      text: '#a8400a',
      border: '#f7b777',
      primary: {
        bg: '#ec4899',
        bgHover: '#db2777',
        bgActive: '#be185d',
        text: '#ffffff',
      },
      disabled: {
        bg: '#fdedd3',
        text: '#f7b777',
        border: '#fbd5a6',
      },
    },
    input: {
      bg: '#ffffff',
      border: '#f7b777',
      borderHover: '#f39247',
      borderFocus: '#ec4899',
      text: '#722b11',
      placeholder: '#f7b777',
    },
    toggle: {
      bg: '#f7b777',
      bgActive: '#ec4899',
      thumb: '#ffffff',
    },
    executing: '#d97706',
    focus: '#ec4899',
    overlay: {
      light: 'rgba(114, 43, 17, 0.1)',
      medium: 'rgba(114, 43, 17, 0.2)',
      heavy: 'rgba(114, 43, 17, 0.3)',
      white: 'rgba(255, 255, 255, 0.1)',
    },
    shadow: {
      medium: 'rgba(236, 72, 153, 0.15)',
    },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    // Legacy spacing
    small: '8px',
    medium: '16px',
    large: '24px',
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      xxxl: '30px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    text: {
      xs: '12px',
      small: '14px',
      medium: '16px',
    },
  },
  borderRadius: {
    sm: '6px',
    md: '10px',
    lg: '16px',
    full: '9999px',
    // Legacy border radius
    small: '3px',
    medium: '8px',
  },
  shadows: {
    xs: '0 1px 2px 0 rgba(236, 72, 153, 0.05)',
    sm: '0 1px 3px 0 rgba(236, 72, 153, 0.08), 0 1px 2px -1px rgba(236, 72, 153, 0.08)',
    md: '0 4px 6px -1px rgba(236, 72, 153, 0.08), 0 2px 4px -2px rgba(236, 72, 153, 0.08)',
    lg: '0 10px 15px -3px rgba(236, 72, 153, 0.08), 0 4px 6px -4px rgba(236, 72, 153, 0.08)',
    xl: '0 20px 25px -5px rgba(236, 72, 153, 0.08), 0 8px 10px -6px rgba(236, 72, 153, 0.08)',
  },
  zIndex: {
    dropdown: 100,
    sticky: 200,
    overlay: 500,
    modal: 1000,
    toast: 2000,
    // Legacy z-index
    base: 0,
    accent: 5,
    content: 10,
    floating: 20,
  },
  transitions: {
    fast: '150ms cubic-bezier(0.4, 0, 0.2, 1)',
    base: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1536px',
  },
};


